<!--
* 组件名 : 撒但的逻辑法则与邪说谬论
* 开发者 : JY
*
* 参数:
*   data         { Object } -  撒旦逻辑法则
* 事件: null
*
*
-->

<template>
  <div class="satan-logical-laws-fallacies" ref="satanRulesBox">
    <div class="rule-text-content" v-html="data.content"></div>
    <div class="arrow-box d-flex justify-content-center" ref="arrowBox">
      <v-btn class="page-arrow" @btnClick="read_more($event)"
        ><span>{{ btnText }}</span
        ><v-icon>expand_more</v-icon></v-btn
      >
    </div>
  </div>
</template>

<script>
import { getStyle } from "@/utils/util";
export default {
  name: "satan-logical-laws-fallacies",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    this.listHeight = 0;
    this.$textContent = null;
    this.isOn = false;
    return {
      btnText: this.$TL.expandAll,
    };
  },
  components: {},
  created() {},
  mounted() {
    this.init_list_height();
  },
  beforeDestroy() {},
  methods: {
    /**
     * 初始化列表高度
     */
    init_list_height() {
      let $satanRulesBox = $(this.$refs.satanRulesBox);
      let boxPaTop = parseInt(getStyle($satanRulesBox.get(0)).paddingTop);
      let boxPaBtm = parseInt(getStyle($satanRulesBox.get(0)).paddingBottom);
      let titH = $satanRulesBox.find(".childTitle").outerHeight(true);
      let arrowBoxH = $satanRulesBox.find(".arrow-box").outerHeight();
      let [addedH, liH, H] = [boxPaTop + boxPaBtm + titH + arrowBoxH, 0, 0];
      let winH = this.$P.isLatin ? window.innerHeight * 2 : window.innerHeight;

      this.$textContent = $satanRulesBox.find(".textContent");
      //  配置语言为两行显示
      let langArr = ["zh-CN", "zh-TW"];
      $satanRulesBox.find(".rules li").map((i, el) => {
        liH += $(el).outerHeight(true);
        H = langArr.indexOf($("body").data("lang")) > -1 ? liH / 2 : liH;

        if (H > winH - addedH) {
          el.classList.add("d-none");
        }
      });
      //  确定最终要显示出来的 li ，再获取ul高度更准确些
      this.listHeight = this.$textContent.outerHeight();
      this.$textContent.css({ height: `${this.listHeight}px` });
      this.$textContent.find("li").removeClass("d-none");
    },

    /**
     * 列表的展开收起操作
     */
    read_more(ev) {
      if (this.isOn) {
        this.btnText = this.$TL.expandAll;
        this.$textContent.velocity({ height: this.listHeight });
        this.$refs.satanRulesBox.classList.remove("open");
        this.isOn = false;
      } else {
        this.btnText = this.$TL.packUp;
        this.$textContent.velocity({
          height: this.$textContent.get(0).scrollHeight,
        });
        this.$refs.satanRulesBox.classList.add("open");
        this.isOn = true;
      }
    },
  },
};
</script>

<style lang="scss">
.satan-logical-laws-fallacies {
  padding-top: 84px;
  padding-bottom: 60px;
  background-color: $color-bg-cyan;
  min-height: 100vh;

  &.open {
    .page-arrow {
      i {
        transform: rotate(180deg);
      }
    }
  }

  .rule-text-content {
    width: 950px;
    margin: auto;

    .childTitle {
      font-size: 30px;
      margin-bottom: 24px;
      text-align: center;
      font-weight: 700;
      font-family: "source-han-serif-sc";
      color: $color-chapter-title;
    }

    .textContent {
      overflow: hidden;

      li {
        font-size: 20px;
        margin-bottom: 16px;
      }
    }
  }

  .page-arrow {
    margin-top: 12px;

    i,
    span {
      color: $color-second-title;
    }
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .satan-logical-laws-fallacies {
    .rule-text-content {
      .textContent {
        @include flex(null, null, wrap);
        li {
          width: 50%;
          &:nth-of-type(2n -1) {
            padding-right: 12px;
          }
          &:nth-of-type(2n) {
            padding-left: 12px;
          }
        }
      }
    }
  }
}

body.latin {
  .satan-logical-laws-fallacies {
    .rule-text-content .childTitle {
      font-family: Georgia;
    }
  }
}
</style>
